<template>
  <div>
    <p class="titleModal">
      {{ $t(`technicalFile.cooling.step2.title`) }}
    </p>
    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.filtration"
          :label="$t('technicalFile.cooling.step2.filtration')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="yesOrno"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.type"
          :label="$t('technicalFile.cooling.step2.type')"
          :items="displayedUnits('filtrationType')"
          :disabled="data.filtration !== 0"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="filtrationType"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
        md="4"
      >
        <VTextField
          v-model="data.capacity.value"
          :label="$t('technicalFile.cooling.step2.capacity')"
          :disabled="data.filtration !== 0"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="2"
        class="noYPadding"
      >
        <VSelect
          v-model="data.capacity.units"
          :label="$t('technicalFile.cooling.step2.units')"
          :items="displayedUnits('capacity')"
          :disabled="data.filtration !== 0"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="capacity"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="noYPadding"
      >
        <VSelect
          v-model="data.operation"
          :label="$t('technicalFile.cooling.step2.operation')"
          :items="displayedUnits('operation')"
          :disabled="data.filtration !== 0"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="operation"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Filtration',
    components: {
        VTextField,
    },
    props: {
        filtration: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                capacity: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        filtration: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.filtration) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { filtration: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.noYPadding {
    padding-bottom: 0;
    padding-top: 0;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
